/**
 * Quota 转换工具
 * 处理人民币 ↔ OneAPI quota 的精确转换
 *
 * OneAPI 内部基准：QuotaPerUnit = 500000（$1 = 500000 quota），USD2RMB = 7
 * ¥1 = 500000 / 7 ≈ 71429 quota
 * 默认 quota_per_cny = 71429（与 OneAPI 内部汇率一致）
 */

var QUOTA_PER_CNY_KEY = 'quota_per_cny';
var DEFAULT_QUOTA_PER_CNY = 71429;

/** 获取当前 quota_per_cny 配置 */
function getQuotaPerCny() {
  var val = localStorage.getItem(QUOTA_PER_CNY_KEY);
  if (val) {
    var num = parseFloat(val);
    if (!isNaN(num) && num > 0) return num;
  }
  return DEFAULT_QUOTA_PER_CNY;
}

/** 设置 quota_per_cny */
function setQuotaPerCny(value) {
  localStorage.setItem(QUOTA_PER_CNY_KEY, String(value));
}

/**
 * quota 转人民币，智能精度显示
 * 大模型场景下单次调用可能只有几厘钱，固定2位小数会丢失精度
 * 规则：>=0.01 显示2位，>=0.001 显示3位，>=0.0001 显示4位，更小显示6位
 * @param {number} quota
 * @returns {string} 如 "12.50" 或 "0.003" 或 "0.0012"
 */
function quotaToCny(quota) {
  if (!quota || quota <= 0) return '0.00';
  var cny = quota / getQuotaPerCny();
  if (cny >= 1) return cny.toFixed(2);
  if (cny >= 0.01) return cny.toFixed(4);
  if (cny >= 0.001) return cny.toFixed(4);
  if (cny >= 0.0001) return cny.toFixed(5);
  return cny.toFixed(6);
}

/**
 * quota 转人民币，返回数字（保留6位精度避免丢失）
 * @param {number} quota
 * @returns {number}
 */
function quotaToCnyNum(quota) {
  if (!quota || quota <= 0) return 0;
  return Math.round(quota / getQuotaPerCny() * 1000000) / 1000000;
}

/**
 * 人民币转 quota，四舍五入取整
 * @param {number} cny
 * @returns {number}
 */
function cnyToQuota(cny) {
  if (!cny || cny <= 0) return 0;
  return Math.round(cny * getQuotaPerCny());
}

/**
 * 格式化 quota 为可读字符串
 * @param {number} quota
 * @returns {string} 如 "71,429"
 */
function formatQuota(quota) {
  if (!quota) return '0';
  return String(quota).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default {
  getQuotaPerCny: getQuotaPerCny,
  setQuotaPerCny: setQuotaPerCny,
  quotaToCny: quotaToCny,
  quotaToCnyNum: quotaToCnyNum,
  cnyToQuota: cnyToQuota,
  formatQuota: formatQuota,
  DEFAULT_QUOTA_PER_CNY: DEFAULT_QUOTA_PER_CNY
};



// WEBPACK FOOTER //
// ./src/utils/quota.js